// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aggCol {
    width: 200px;
    align-self: center;
    margin: 0px 4px;
}

.groupCol {
    min-width: 200px;
    align-self: center;
    margin: 0px 4px;
    flex: 1 1 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/dataoperations/aggregate/aggregate.settings.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB","sourcesContent":[".aggCol {\n    width: 200px;\n    align-self: center;\n    margin: 0px 4px;\n}\n\n.groupCol {\n    min-width: 200px;\n    align-self: center;\n    margin: 0px 4px;\n    flex: 1 1 auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
